import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addOn: string;
    upgrade: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for Enterprise subscribers viewing features */
            addOn: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeatureGateLabel.addOn?c=qpw8ke5n33v4", defaultMessage: "Add-on" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for retail users viewing version upgrades */
            upgrade: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeatureGateLabel.upgrade?c=3j8ivic2l2dgb", defaultMessage: "Upgrade" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
